import { getScrollContainer } from './getScrollContainer'

/**
 * **Muss überhaupt gescrollt werden?**
 *
 * `scrollIntoView({ block: 'nearest' })` klingt, als täte es nichts, wenn das
 * Element schon dasteht — tut es aber doch, sobald es auch nur um einen
 * Bruchteil über die Kante ragt. Mit `behavior: 'smooth'` zieht der Browser
 * danach eine Viertelsekunde lang nach und kommt mit anderthalb Pixeln zur
 * Ruhe. Genau das war das lange gesuchte „Hüpfen" nach dem Anlegen einer
 * Aufgabe (gemessen am 21.09.2026: ein einziger Aufruf aus `useTaskCreation`,
 * danach 72 → 26 → 20 → 2,4 → 1,5 px).
 *
 * Darum vorher fragen. Steht das Element ganz im Bild, bleibt alles stehen.
 *
 * @param el Das Element, das sichtbar sein soll.
 * @param rand Sicherheitsabstand zu den Kanten in Pixeln — über der Liste
 *   liegt ein Verlauf, und was darunter steckt, gilt nicht als sichtbar.
 */
export function needsScrollIntoView(el: HTMLElement | null | undefined, rand = 0): boolean {
  if (!el) return false

  const kasten = el.getBoundingClientRect()
  // Ohne Maße (frisch angelegt, verborgener Tab) lieber nicht scrollen:
  // Ein Scroll auf ein ungemessenes Element springt irgendwohin.
  if (kasten.height === 0 && kasten.width === 0) return false

  const container = getScrollContainer(el)
  const sichtbar = container
    ? container.getBoundingClientRect()
    : { top: 0, bottom: window.innerHeight }

  return kasten.top < sichtbar.top + rand || kasten.bottom > sichtbar.bottom - rand
}
